import PlayerBasicModel from "../../Football/Models/Player/PlayerBasicModel";

export default class PlayerPointsModel {
  public playerId: string = null;
  public playerModel: PlayerBasicModel = null;
  public points: number = null;
  public rank: number = null;
}